import { AfterViewChecked, Component, ElementRef, Input, QueryList, ViewChildren  } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-radio-list-box',
  templateUrl: './radio-list-box.component.html',
  styleUrls: ['./radio-list-box.component.css']
})
export class RadioListBoxComponent  extends ControlBaseDirective implements AfterViewChecked {
  @Input() source: any[] = [];
  @ViewChildren('radiobutton') public radiobuttons!: QueryList<ElementRef>;
  @Input() formGroup: FormGroup = {} as FormGroup;
  value: any;
  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    super(roleService, applicationContext);
  }
  ngAfterViewChecked(): void {
    this.value =  this.control?.value ?  this.control?.value[this.idField]: this.value;
    if (this.value) {
      const found = this.source.find(x => x[this.idField] === this.value);
      const index = this.source.indexOf(found);
      const radioFound = this.radiobuttons.get(index);
      if (radioFound) {
        radioFound.nativeElement.setAttribute('checked', true);
      }
    }
    super.ngAfterContentInit();
  }

  public setControl(value: any) {
    this.control.setValue(value);
  }
}